import './FollowSuggestions.sass';

import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { BottomBar, Button, Header, ScrollView } from '$uikit';
import { Loader } from '$shared/components';
import { useTranslator } from '$hooks';
import { Api } from '$api';
import { mainActions } from '$store/main';
import { RecommendationsSliderItem } from '$core/Feed/RecommendationsSliderItem/RecommendationsSliderItem';
import { goBack, showModal } from '$navigation/helper';
import { isNotificationsSupported, statReachGoal } from '$utils';

export const FollowSuggestions: React.FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();

  const [loadingStatus, setLoadingStatus] = useState('loading');
  const [list, setList] = useState<number[]>([]);
  const [followCount, setFollowCount] = useState(0);

  const loadData = useCallback(() => {
    setLoadingStatus('loading');
    Api.get('/followers/suggestions')
      .then((res) => {
        const data: any = res;
        dispatch(mainActions.setUsers(data.users));
        setList(data.list);
        setLoadingStatus('');
      })
      .catch(() => {
        setTimeout(() => loadData(), 3000);
      });
  }, []);

  useEffect(() => {
    loadData();
    statReachGoal('follow_suggestions_show');
  }, []);

  const handleDone = useCallback(() => {
    if (isNotificationsSupported()) {
      showModal('push_notifications', true);
    } else {
      goBack();
    }
    statReachGoal('follow_suggestions_done');
  }, []);

  const handleClose = useCallback(() => {
    goBack();
    statReachGoal('follow_suggestions_close');
  }, []);

  const handleFollowed = useCallback(() => {
    setFollowCount((prev) => prev + 1);
    statReachGoal('follow_suggestions_follow');
  }, []);

  function renderContent() {
    if (loadingStatus === 'loading') {
      return <Loader isWrapped />;
    }

    return (
      <div className="RecommendationsSlider FollowSuggestions__items">
        {list.map((uid) => {
          return (
            <RecommendationsSliderItem
              userId={uid}
              key={uid}
              showUnfollow
              onFollowed={handleFollowed}
            />
          );
        })}
      </div>
    );
  }

  return (
    <>
      <Header showCloseButton backButtonOnClick={handleClose}>
        {t('follow_suggestions_title')}
      </Header>
      <ScrollView>{renderContent()}</ScrollView>
      {followCount > 1 && (
        <BottomBar>
          <Button onClick={handleDone} stretched>
            {t('follow_suggestions_done_btn')}
          </Button>
        </BottomBar>
      )}
    </>
  );
};
